import { SvgIconComponent } from '../types/svgs';

const ActivityAssessment: SvgIconComponent = ({ className }) => {
  return (
    <svg
      className={className}
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.75 11.75V10.25M6 11.75V8.75M8.25 11.75V7.25M9.75 14.75H2.25C1.85218 14.75 1.47064 14.592 1.18934 14.3107C0.908035 14.0294 0.75 13.6478 0.75 13.25V2.75C0.75 2.35218 0.908035 1.97064 1.18934 1.68934C1.47064 1.40804 1.85218 1.25 2.25 1.25H6.4395C6.6384 1.25004 6.82913 1.32909 6.96975 1.46975L11.0303 5.53025C11.1709 5.67087 11.25 5.8616 11.25 6.0605V13.25C11.25 13.6478 11.092 14.0294 10.8107 14.3107C10.5294 14.592 10.1478 14.75 9.75 14.75Z"
        stroke="#394642"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ActivityAssessment;
